export enum QuestionType {
  /**
    * åéé¢
    */
  SINGLE_SELECT = 'SINGLE_SELECT',
  /**
   * å¤éé¢
   */
  MULTI_SELECT = 'MULTI_SELECT',
  /**
   * ä¸å®é¡¹
   */
  UNCERTAIN_SELECT = 'UNCERTAIN_SELECT',
  /**
   * å¤æ­é¢
   */
  TRUE_OR_FALSE = 'TRUE_OR_FALSE',
  /**
   * å¡«ç©ºé¢
   */
  FILL_BLANK = 'FILL_BLANK',
  /**
   * é®ç­é¢
   */
  SHORT_ANSWER = 'SHORT_ANSWER',
  /**
    * æ¡ä¾é¢
    */
  CASE_QUS = 'CASE_QUS'
}
